/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  Grid,
  TextField,
  MenuItem,
  Checkbox,
  ListItemText,
  Paper,
  Typography,
} from "@material-ui/core";
import { API } from "../../apis/api";
import useSharedStyles from "./SharedStyle";

const StatusInformation = ({ formData, handleChange,setCaseTypeOptions, ...props }) => {
  const classes = useSharedStyles();
  const [caseTypeNames, setCaseTypeNames] = useState([]);
  const userId = useSelector((state)=>state.auth.user.userId)

  const { isEditMode, disabled } = props;

  const fetchCaseTypes = async () => {
  try {
    const response = await API.post("/ticket/checklist-list/",{sub:userId});
    if (response.data.success) {
      const activeChecklists = response.data.data
        .filter((item) => item.is_active)
        .map((item) => ({
          id: item.id,
          name: item.name,
        }));

      // Set full object array to parent
      setCaseTypeOptions(activeChecklists);

      // Set just names locally for rendering select
      setCaseTypeNames(activeChecklists.map((item) => item.name));
    }
  } catch (err) {
    console.error("Failed to fetch case types:", err);
    const fallback = [
      "Indian Resident - Share certf",
      "Indian Resident - Demat",
      "NRI - Share certf",
      "NRI - Demat",
      "Body corporate - Demat",
      "Body corporate - SC",
      "Legal document pointers",
    ];
    setCaseTypeNames(fallback);
    setCaseTypeOptions(
      fallback.map((name, index) => ({ id: index + 1, name }))
    );
  }
};


  useEffect(() => {
    fetchCaseTypes();
  }, []);

  const renderSelect = ({
    name,
    label,
    options,
    multiple = false,
    required = false,
    disabledThis = false,
  }) => (
    <>
      <Typography className={classes.label}>
        {label}
        {required && <span className={classes.requiredAsterisk}>*</span>}
      </Typography>
      <TextField
        select
        variant="outlined"
        size="small"
        fullWidth
        id={name}
        name={name}
        value={formData[name] || (multiple ? [] : "")}
        onChange={handleChange}
        SelectProps={{
          multiple,
          renderValue: multiple
            ? (selected) => {
                if (Array.isArray(selected)) {
                  return selected.join(", ");
                }
                return String(selected);
              }
            : undefined,
        }}
        required={required}
        className={classes.inputField} 
        style={{ textTransform: "capitalize" }} 
        autoComplete="off"
        disabled={disabled || disabledThis} 
      >
        {options.map((option) => (
          <MenuItem
            key={option}
            value={option}
            style={{ textTransform: "capitalize" }}
          >
            {multiple ? (
              <>
                <Checkbox
                  checked={formData[name]?.indexOf(option) > -1}
                  color="primary"
                />
                <ListItemText primary={option} />
              </>
            ) : (
              option
            )}
          </MenuItem>
        ))}
      </TextField>
    </>
  );

  const baseStatusOptions = ["accept", "rectify", "reject"];
  const currentStatus = formData.status;
  const allStatusOptions =
    currentStatus && !baseStatusOptions.includes(currentStatus)
      ? [...baseStatusOptions, currentStatus]
      : baseStatusOptions;

  return (
    <Paper className={classes.paper} elevation={2}>
      <Typography variant="h6" className={classes.sectionTitle}>
        Status Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          {renderSelect({
            name: "signatureMismatch",
            label: "Signature Mismatch",
            options: ["Yes", "No", "NA (Demat A/c)"],
            required: true,
          })}
        </Grid>
        <Grid item xs={12} md={4}>
          {renderSelect({
            name: "securityMismatch",
            label: "Mismatch in Nature of Security",
            options: ["Yes", "No"],
            required: true,
          })}
        </Grid>
        <Grid item xs={12} md={4}>
          {renderSelect({
            name: "litigationPending",
            label: "Any Litigation Pending",
            options: ["Yes", "No"],
            required: true,
          })}
        </Grid>
        <Grid item xs={12} md={4}>
          {renderSelect({
            name: "status",
            label: "Status",
            options: allStatusOptions,
            required: true,
            disabledThis: isEditMode, // Disable if in edit mode
          })}
        </Grid>
        <Grid item xs={12} md={8}>
          {renderSelect({
            name: "caseType",
            label: "Case Type",
            options: caseTypeNames,
            required: true,
            disabledThis: isEditMode, // Disable if in edit mode
          })}
        </Grid>
      </Grid>
    </Paper>
  );
};

StatusInformation.propTypes = {
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  setCaseTypeOptions: PropTypes.func,
};

export default StatusInformation;